<template>
  <svg
    width="104"
    height="104"
    viewBox="0 0 104 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52 104C58.8287 104 65.5906 102.655 71.8995 100.042C78.2085 97.4285 83.9409 93.5982 88.7695 88.7695C93.5982 83.9409 97.4285 78.2085 100.042 71.8995C102.655 65.5906 104 58.8287 104 52C104 45.1713 102.655 38.4094 100.042 32.1005C97.4285 25.7915 93.5982 20.0591 88.7695 15.2304C83.9409 10.4018 78.2085 6.57151 71.8995 3.95826C65.5906 1.34502 58.8287 -1.01756e-07 52 0C38.2087 2.05506e-07 24.9823 5.47855 15.2304 15.2304C5.47856 24.9823 0 38.2087 0 52C0 65.7913 5.47856 79.0177 15.2304 88.7695C24.9823 98.5214 38.2087 104 52 104ZM50.6596 73.0311L79.5484 38.3644L70.6738 30.9689L45.8293 60.7764L32.9738 47.9151L24.804 56.0849L42.1373 73.4182L46.6093 77.8902L50.6596 73.0311Z"
      fill="#378F3A"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconCheckCircle',
  }
</script>
